import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

function ConfirmReservation() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState("loading");
  const [organisation, setOrganisation] = useState(null); 
  // loading | success | error

  useEffect(() => {
    const confirm = async () => {
      try {
        const token = searchParams.get("token");

        if (!token) {
          setStatus("error");
          return;
        }

        /* 🆕 ORGANISATION — le mail propose de confirmer aux frais d'une
           organisation ou à titre personnel. Les deux paramètres viennent
           du lien cliqué et sont transmis tels quels. */
        const res = await axios.get(
          `https://api.komorotel.com/api/reservation/confirm`,
          {
            params: {
              token,
              ...(searchParams.get("mode") ? { mode: searchParams.get("mode") } : {}),
              ...(searchParams.get("org")  ? { org:  searchParams.get("org")  } : {}),
            }
          }
        );

        setOrganisation(res.data.organizationName || null);
        setStatus("success");

        const reservationId = res.data.reservationId;

        setTimeout(() => {
        navigate("/confirmation/" + reservationId);
        }, res.data.organizationName ? 3000 : 1500);

      } catch (err) {
        console.log(err);
        setStatus("error");
      }
    };

    confirm();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">

        <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 text-center">

            {/* LOADING */}
            {status === "loading" && (
            <>
                <div className="flex justify-center mb-6">
                <div className="w-12 h-12 border-4 border-gray-200 border-t-[var(--k-green)] rounded-full animate-spin"></div>
                </div>

                <h1 className="text-lg font-semibold text-gray-900 mb-2">
                Confirmation en cours...
                </h1>

                <p className="text-sm text-gray-500">
                Nous validons votre réservation ⏳
                </p>
            </>
            )}

            {/* SUCCESS */}
            {status === "success" && (
            <>
                <div className="flex justify-center mb-6">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-green-100">
                    <svg
                    className="w-8 h-8 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    viewBox="0 0 24 24"
                    >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                </div>
                </div>

                <h1 className="text-xl font-semibold text-gray-900 mb-2">
                {organisation ? "Demande enregistrée" : "Réservation confirmée 🎉"}
                </h1>

                <p className="text-sm text-gray-500">
                {organisation
                  ? `Vos dates sont tenues. ${organisation} doit valider la prise en charge, vous recevrez un message dès que ce sera fait.`
                  : "Votre séjour est validé. Redirection en cours..."}
                </p>
            </>
            )}

            {/* ERROR */}
            {status === "error" && (
            <>
                <div className="flex justify-center mb-6">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-red-100">
                    <svg
                    className="w-8 h-8 text-red-600"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    viewBox="0 0 24 24"
                    >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                </div>

                <h1 className="text-xl font-semibold text-gray-900 mb-2">
                Lien invalide ou expiré
                </h1>

                <p className="text-sm text-gray-500 mb-6">
                Votre réservation n’a pas pu être confirmée.  
                Veuillez recommencer.
                </p>

                <button
                onClick={() => navigate("/")}
                className="w-full py-2.5 rounded-lg bg-gray-900 text-white text-sm font-medium hover:bg-gray-800 transition"
                >
                Retour à l’accueil
                </button>
            </>
            )}

        </div>
        </div>
  );
}

export default ConfirmReservation;